export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5005";
export const API_WS_URL = import.meta.env.VITE_API_WS_URL || "ws://localhost:5005";
